import IdLessRestService from "./IdLessRestService";


export default class SendoutService extends IdLessRestService {
    constructor() {
        super('/public/sendouts');
    }
}
